import Request from "../../lib/request";
import {
  APPROVE_API,
  FINALIZE_API,
  IMPRESTS_API,
  ITEMS_API,
  PROJECT_USER_LIST_API,
  PROJECT_USERS_API,
  REJECT_FINALIZE_API,
  REJECT_TO_API,
  RETURN_API,
  TRASHED_SEQUENCE_API
} from "../../constants/api";
import { PROJECT_USER_ID } from "../../constants/storageKeys";
import { PAGE, PER_PAGE } from "../../constants/filters";

const baseUrl = process.env.REACT_APP_API_ADMIN_URL;
const nonAdminBaseUrl = process.env.REACT_APP_API_URL;

export const get = id => {
  const projectUserId = localStorage.getItem(PROJECT_USER_ID);
  return Request({
    method: "get",
    url: `${baseUrl}/${PROJECT_USERS_API}/${projectUserId}/${IMPRESTS_API}/${id}`,
    needToken: true
  });
};

export const getItems = (id, pageNum) => {
  const projectUserId = localStorage.getItem(PROJECT_USER_ID);
  return Request({
    method: "get",
    url: `${baseUrl}/${PROJECT_USERS_API}/${projectUserId}/${IMPRESTS_API}/${id}/${ITEMS_API}${
      pageNum ? "?item-page=" + pageNum : ""
    }`,
    needToken: true
  });
};

export const getList = (page_number, finalFilter) => {
  const projectUserId = localStorage.getItem(PROJECT_USER_ID);
  return Request({
    method: "get",
    url: `${baseUrl}/${PROJECT_USERS_API}/${projectUserId}/${IMPRESTS_API}`,
    needToken: true,
    params: {
      ...finalFilter,
      [PAGE]: page_number
    }
  });
};

export const getListTrashedSequence = (page_number, finalFilter) => {
  const projectUserId = localStorage.getItem(PROJECT_USER_ID);
  return Request({
    method: "get",
    url: `${baseUrl}/${PROJECT_USERS_API}/${projectUserId}/${TRASHED_SEQUENCE_API}`,
    needToken: true,
    params: {
      ...finalFilter,
      [PAGE]: page_number
    }
  });
};

export const sendBack = (id, data) => {
  const projectUserId = localStorage.getItem(PROJECT_USER_ID);
  return Request({
    method: "post",
    url: `${baseUrl}/${PROJECT_USERS_API}/${projectUserId}/${IMPRESTS_API}/${id}/${RETURN_API}`,
    needToken: true,
    data
  });
};

export const reject = (id, data) => {
  const projectUserId = localStorage.getItem(PROJECT_USER_ID);
  return Request({
    method: "post",
    url: `${baseUrl}/${PROJECT_USERS_API}/${projectUserId}/${IMPRESTS_API}/${id}/${REJECT_TO_API}`,
    needToken: true,
    data
  });
};

export const rejectFinalize = (id, data) => {
  const projectUserId = localStorage.getItem(PROJECT_USER_ID);
  return Request({
    method: "post",
    url: `${baseUrl}/${PROJECT_USERS_API}/${projectUserId}/${IMPRESTS_API}/${id}/${REJECT_FINALIZE_API}`,
    needToken: true,
    data
  });
};

export const approve = (id, data) => {
  const projectUserId = localStorage.getItem(PROJECT_USER_ID);
  return Request({
    method: "post",
    url: `${baseUrl}/${PROJECT_USERS_API}/${projectUserId}/${IMPRESTS_API}/${id}/${APPROVE_API}`,
    needToken: true,
    data
  });
};

export const finalize = id => {
  const projectUserId = localStorage.getItem(PROJECT_USER_ID);
  return Request({
    method: "post",
    url: `${baseUrl}/${PROJECT_USERS_API}/${projectUserId}/${IMPRESTS_API}/${id}/${FINALIZE_API}`,
    needToken: true
  });
};

export const getUsersList = params => {
  const projectUserId = localStorage.getItem(PROJECT_USER_ID);
  return Request({
    method: "get",
    url: `${nonAdminBaseUrl}/${PROJECT_USERS_API}/${projectUserId}/${PROJECT_USER_LIST_API}`,
    needToken: true,
    params: params //{states, user_types}
  });
};
